export enum ExperienceType {
  EXPERIENCE,
  EDUCATION,
  QUALIFICATION,
  PUBLICATION,
}

export enum BackgroundColor {
  PINK = 'pink',
  ORANGE = 'orange',
  PURPLE = 'purple',
  GREEN = 'green',
  DEFAULT = 'default',
}
